import axios from "axios";

import { API_BASE_URL } from "./apiBase";

export { API_BASE_URL };

export const api = axios.create({
  baseURL: API_BASE_URL,
});
